import { render, staticRenderFns } from "./ring2.vue?vue&type=template&id=7944c103&scoped=true&"
import script from "./ring2.vue?vue&type=script&lang=js&"
export * from "./ring2.vue?vue&type=script&lang=js&"
import style0 from "./ring2.vue?vue&type=style&index=0&id=7944c103&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7944c103",
  null
  
)

export default component.exports